// extracted by mini-css-extract-plugin
module.exports = {"container":"purify_styles__container--111uh","link":"purify_styles__link--UvW3s"};